import script from "./ScopeLoadProgress.vue?vue&type=script&lang=ts&setup=true"
export * from "./ScopeLoadProgress.vue?vue&type=script&lang=ts&setup=true"

import "./ScopeLoadProgress.vue?vue&type=style&index=0&id=23da783a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23da783a"]])

export default __exports__